import dayjs from "@/lib/day";
export default function calcAge(birthday) {
  const today = dayjs();
  const birthDate = dayjs(birthday);
  const baseAge = today.year() - birthDate.year();
  const thisBirthday = dayjs(
    `${today.year()}-${birthDate.month() + 1}-${birthDate.date()}`
  );
  const age = today.isBefore(thisBirthday) ? baseAge - 1 : baseAge;
  if (isNaN(age)) return 0;
  return age < 0 ? 0 : age;
}
